import styled from 'styled-components';
import { shade } from 'polished';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.button`
  min-width: 180px;
  max-width: 100%;
  width: fit-content;
  height: 48px;
  padding: 0 28px;

  display: flex;

  justify-content: center;
  align-items: center;

  border: none;

  background-color: ${colors.primary};

  color: ${colors.onPrimary};

  border-radius: ${radius.full};

  transition: background-color 0.2s;

  &:hover {
    background-color: ${shade(0.2, colors.primary)};
  }

  span {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &:disabled {
    background-color: ${shade(0.5, colors.primary)};
  }
`;
